angular.module('Const').constant('MapLegendsConst', {
    legend: [
        'p2p',
        'mr',
        'ret',
        'locations',
        'jobClusters'
    ],
    statuses: [
        {
            label: 'Unassigned',
            id: 'UNASSIGNED',
            color: '#959595',
            iconColor: 'gray'
        }, {
            label: 'For Approval',
            id: 'FORAPPROVAL',
            color: '#ed7f00',
            iconColor: ''
        },
        {
            label: 'Pending',
            id: 'PENDING',
            color: '#9804f0',
            iconColor: 'purple'
        },
        {
            label: 'Accepted',
            id: 'ACCEPTED',
            color: '#ee1c24',
            iconColor: 'red'
        },
        {
            label: 'Received',
            id: 'RECEIVED',
            color: '#36b8b7',
            iconColor: 'aqua'
        },
        {
            label: 'In progress',
            id: 'INPROGRESS',
            color: '#0055A6',
            iconColor: 'blue'
        },
        {
            label: 'Failed',
            id: 'FAILED',
            color: '#383838',
            iconColor: 'black'
        },
        {
            label: 'Rejected',
            id: 'REJECTED',
            color: '#ffcc00',
            iconColor: 'yellow'
        },
        {
            label: 'Delivered',
            id: 'DELIVERED',
            color: '#54B948',
            iconColor: 'green'
        }
    ],
    getIcons: function (jobType, status = {iconColor: 'red'}) {
        let iconUrl = '/images/map_icons/jobs/{jobType}{color}.png';
        let jobIcon = {};

        switch (jobType) {
            case 'p2p':
                jobIcon.url = iconUrl.replace('{jobType}', 'p2p').replace('{color}', status.iconColor);
                jobIcon.label = 'P2P'
                break;
            case 'mr':
                jobIcon.url = iconUrl.replace('{jobType}', 'mr').replace('{color}', status.iconColor);
                jobIcon.label = 'Milkrun'
                break;
            case 'ret':
                jobIcon.url = iconUrl.replace('{jobType}', 'ret').replace('{color}', status.iconColor);
                jobIcon.label = 'Returns'
                break;
            case 'locations':
                jobIcon.url = '/images/map_icons/DEPOT.png'
                jobIcon.label = 'Locations'
                break;
            case 'jobClusters':
                jobIcon.url = '/images/map_icons/clusters/redcluster.png'
                jobIcon.label = 'Job clusters'
                break;
        }
        return jobIcon;
    }
    , getDepotIcon: function () {
        return {
            url: '/images/map_icons/DEPOT.png',
            label: 'Locations'
        }
    },
    getClusterIcon: function (jobStatus) {
        let bbaMapClusterIconsPath = '/images/map_icons/clusters/{color}.png';
        const clusterIcons = {
            unassigned: bbaMapClusterIconsPath.replace('{color}', 'greycluster'),
            pending: bbaMapClusterIconsPath.replace('{color}', 'purplecluster'),
            failed: bbaMapClusterIconsPath.replace('{color}', 'black'),
            accepted: bbaMapClusterIconsPath.replace('{color}', 'redcluster'),
            received: bbaMapClusterIconsPath.replace('{color}', 'aquacluster'),
            inprogress: bbaMapClusterIconsPath.replace('{color}', 'bluecluster'),
            delivered: bbaMapClusterIconsPath.replace('{color}', 'greencluster'),
            rejected: bbaMapClusterIconsPath.replace('{color}', 'yellowcluster'),
            drivers: bbaMapClusterIconsPath.replace('{color}', 'vehicle_cluster')
        };
        return clusterIcons[jobStatus.toLowerCase()];
    }
})



// WEBPACK FOOTER //
// ./js/consts/mapLegendsConst.js